(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/lotto/assets/javascripts/router.js');

'use strict';

const getRules = svs.numbergames.rules.getRules;
const playViews = {
  Single: svs.lotto.views.PlaySinglePage,
  System: svs.lotto.views.PlaySystemPage,
  Package: svs.lotto.views.PlayPackagePage
};
svs.lotto.Router = Backbone.Router.extend({
  routes: svs.core.data.routes,
  initialize(_ref) {
    let app = _ref.app;
    svs.lotto.logger.debug('svs.router.lotto initialize');
    this.app = app;
  },
  playSingle() {
    svs.lotto.logger.debug('svs.lotto.Router playSingle');
    this.app.showView(new svs.lotto.views.PlaySinglePage());
  },
  playPackageGame(size) {
    svs.lotto.logger.debug('svs.lotto.Router playPackage');
    const packageSizes = Object.keys(getRules('lotto').PACKAGES);
    if (!size || !packageSizes.includes(size)) {
      size = packageSizes[1];
      this.navigate("fardiga-spel/".concat(size), {
        replace: true
      });
    }
    svs.core.data.title = {
      packageSize: size
    };
    svs.core.data.metaDescription = {
      packageSize: size
    };
    this.app.showView(new svs.lotto.views.PlayPackagePage({
      size
    }));
  },
  playSystem() {
    svs.lotto.logger.debug('svs.lotto.Router playSystem');
    this.app.showView(new svs.lotto.views.PlaySystemPage());
  },
  playProlongation() {
    svs.lotto.logger.debug('svs.lotto.Router prolongWager');
    if (!svs.lotto.data.prolongWager) {
      svs.lotto.logger.warn('svs.lotto.Router prolongWager. No wager to prolong.');
      this.navigate('', {
        trigger: true,
        replace: true
      });
      return;
    }
    const editWagerFunction = svs.numbergames.game.utils.prolongation.getEditWagerFunction({
      playViews,
      modelOptions: {
        hasTickets: svs.lotto.data.hasTickets
      }
    });
    const playedWagerModel = new svs.numbergames.mybets_common_wager.models.Wager(svs.lotto.data.prolongWager, {
      parse: true
    });
    editWagerFunction(playedWagerModel);
  },
  changeSubscription() {
    svs.lotto.logger.debug('svs.lotto.Router changeSubscription');
    const subscription = new svs.numbergames.mybets_common_wager.models.Subscription(svs.lotto.data.subscription, {
      parse: true
    });
    svs.numbergames.game.utils.editWager.showPlayView({
      playedWager: subscription,
      playViews,
      viewOptions: {
        showDrawCount: false,
        showPlayTogether: false
      }
    });
  },
  fractionGames() {
    svs.lotto.logger.debug('svs.lotto.Router fractionGames');
    this.app.showView(new svs.lotto.views.FractiongamesPage());
  },
  prolongation() {
    svs.lotto.logger.debug('svs.lotto.Router prolongation');
    const hasSession = svs.numbergames.game_app.utils.handleProlongLogin();
    if (hasSession) {
      this.app.showView(new svs.lotto.views.ProlongationPage());
    }
  },
  result(dateString) {
    if (dateString) {
      try {
        const date = dateFns.parseISO(dateString);
        const readableDate = dateFns.format(date, 'd MMMM yyyy', {
          locale: dateFns.locales.sv
        });
        svs.core.data.title = {
          readableDate
        };
        svs.core.data.metaDescription = {
          readableDate
        };
      } catch (e) {
        svs.lotto.logger.error('svs.lotto.Router result failed to parse date', e);
      }
    }
    svs.lotto.logger.debug('svs.lotto.Router result');
    this.app.showView(new svs.lotto.views.ResultPage({
      dateString
    }));
  }
});

 })(window);